// extracted by mini-css-extract-plugin
export default {"slide":"style_slide__7qkc+","slider":"style_slider__O4t0U","information":"style_information__OFr4M","title":"style_title__iy135","body":"style_body__hM10Y"};